export default __webpack_public_path__ + "empty-pipeline-md.da65fef9.svg";